export default {"src":"/_next/static/media/logo.56c2c2cd.svg","height":35,"width":150,"blurWidth":0,"blurHeight":0};